import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { AddIcon, RefreshIcon } from 'icons/materialIcons';
import TeamWhiteButtonWithIcon from 'team/shared/components/button/TeamWhiteButtonWithIcon';
import RequestIntegrationModal from './RequestIntegrationModal';
import TeamNotificationSnackbar from 'team/shared/components/notification/TeamNotificationSnackbar';

const TeamIntegrationsMenu = ({ onRefresh }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const handleRequestIntegration = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleSubmitSuccess = (message) => {
        setNotification({
            open: true,
            message: message,
            severity: 'success'
        });
    };

    const handleSubmitError = (errorMessage) => {
        setNotification({
            open: true,
            message: errorMessage,
            severity: 'error'
        });
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                    mb: 3
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" component="h1">
                        Integrations
                    </Typography>
                    {onRefresh && (
                        <IconButton
                            onClick={onRefresh}
                            size="small"
                            sx={{ ml: 1 }}
                            title="Refresh integrations"
                        >
                            <RefreshIcon />
                        </IconButton>
                    )}
                </Box>

                <TeamWhiteButtonWithIcon
                    text="Request an Integration"
                    icon={AddIcon}
                    onClick={handleRequestIntegration}
                    sx={{
                        fontWeight: 700
                    }}
                    iconPosition="start"
                />
            </Box>

            <RequestIntegrationModal
                open={modalOpen}
                onClose={handleCloseModal}
                onSubmitSuccess={handleSubmitSuccess}
                onSubmitError={handleSubmitError}
            />

            <TeamNotificationSnackbar
                open={notification.open}
                message={notification.message}
                severity={notification.severity}
                handleClose={() => setNotification({ ...notification, open: false })}
            />
        </>
    );
};

export default TeamIntegrationsMenu;

